import { render } from "./actionResult.vue?vue&type=template&id=167be4f5&scoped=true"
import script from "./actionResult.vue?vue&type=script&lang=js"
export * from "./actionResult.vue?vue&type=script&lang=js"

import "./actionResult.vue?vue&type=style&index=0&id=167be4f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167be4f5"]])

export default __exports__